import { render } from "./LinkageSignupComplete.vue?vue&type=template&id=177ce896&scoped=true&ts=true"
import script from "./LinkageSignupComplete.vue?vue&type=script&lang=ts"
export * from "./LinkageSignupComplete.vue?vue&type=script&lang=ts"

import "./LinkageSignupComplete.vue?vue&type=style&index=0&id=177ce896&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3623750061/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177ce896"]])

export default __exports__